import React, { useEffect } from "react";
import Modal from "react-modal";
import 'assets/scss/components/commonModal.scss';


const CommonModal = ({children,isOpen,title,onRequestClose,className}) => {
    // 모달이 열릴 때 스크롤 방지
    useEffect(() => {
        if (isOpen) {
            const ptrContainer = document.querySelector('.ptr-scroll-container');
            const savedScrollTop = ptrContainer ? ptrContainer.scrollTop : 0;

            // 기존 스타일 값들 저장
            const originalHtmlOverflow = document.documentElement.style.overflow;
            const originalBodyOverflow = document.body.style.overflow;

            // 스크롤 방지 설정
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            if (ptrContainer) {
                ptrContainer.style.overflow = 'hidden';
            }

            // 컴포넌트 언마운트 시 원래 상태로 복원
            return () => {
                document.documentElement.style.overflow = originalHtmlOverflow;
                document.body.style.overflow = originalBodyOverflow;
                if (ptrContainer) {
                    ptrContainer.style.overflow = '';
                    ptrContainer.scrollTop = savedScrollTop;
                }
            };
        }
    }, [isOpen]);

    // 모달 내부 클릭 시 이벤트 전파 방지
    const handleModalContentClick = (e) => {
        e.stopPropagation();
    };

    return(
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={`common-modal-wrap ${className || ''}`}
            overlayClassName="common-modal-overlay"
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
        >
            <div className="common-modal-content" onClick={handleModalContentClick}>
                {title && <h2 className="common-modal-title">{title}</h2>}
                <div className="common-modal-body">
                    {children}
                </div>
            </div>
        </Modal>
    )
};

export default CommonModal;